import React, { Component } from 'react';
import { Route } from 'react-router';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Assessment } from './components/Assessment';
import { UserInfo } from './components/UserInfo';
import { Activities } from './components/Activities';

export default class App extends Component {
    displayName = App.name

    render() {
        return (
            <div className="l-body" key="mainAppRouter" id="BodyTag">
                <div className="l-flex">
                    <Header />
                    <Assessment>
                        <Route exact path='/' component={Assessment} />
                        <Route path='/UserInfo' component={UserInfo} />
                        <Route path='/Activities' component={Activities} />
                    </Assessment>
                </div>
                <Footer />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App.js